//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'

export default {
    layout: 'default',
    // middleware: 'guest',

    data(){ return {
        videos: []
    }},

    metaInfo(){ return {
        title: 'YTM|Gallery',
        link: [
            { rel: 'canonical', href: window.location.href }
        ],
        meta: this.$rm.getMeta(this), //this.$route.meta
    }},

    mounted(){
        // this.load()
    },

    beforeRouteEnter(to, from, next){
            axios.get('/api/ytm/v1/videos/all')
                 .then( r =>  {
                      next( vm => {
                          vm.videos = r.data.videos
                      })
                  })
                 .catch( e => {
                      console.log(e)
                      next(vm => {
                          vm.loadingError = true
                      })
                 })
    },

    computed: {
        user(){ return this.$store.getters['auth/user'] },
        title(){
            return 'Gallery {' + this.videos.length + '}'
        }
    },

    methods: {

        load(){
            axios.get('/api/ytm/v1/videos/all')
                 .then( r => {
                      this.videos = r.data.videos
                 })
                 .catch( e => console.log(e) )
        },

        intersect(entry, item, i){
            if(entry.isIntersecting){
                item.showInfo = true
            }
        },

        getDefaultImageURL(video){
            return video.url
        },


    }
}
